const en = {
    translation: {
        button: {
            cancel: 'CANCEL',
            close: 'CLOSE',
            requestIncrease: 'REQUEST INCREASE'
        },
        cliBusinessError: {
            subTitle: 'You will receive a letter in 7-10 business days explaining the reason for our decision.',
            title: 'Your credit limit cannot be increased at this time'
        },
        cliPartialSuccess: {
            subTitle: 'We are unable to grant the full amount that you requested. However, we were able to increase your credit limit. You will receive a letter in 7-10 business days explaining the reason for our decision.'
        },
        cliPendingReferral: {
            subTitle: 'We are reviewing your request. You will receive a letter in 7-10 business days with your request decision.',
            title: 'Your credit limit request is pending'
        },
        cliSuccess: {
            newLimit: 'NEW CREDIT LIMIT',
            subText: 'Your credit limit is available for immediate use.',
            subTitle: 'Your request for a credit limit increase has been approved for the following:',
            title: 'We increased your credit limit'
        },
        errorMessages: {
            unableToProcessRequest: 'Unfortunately we are unable to process your request at this time. Please try again later.'
        },
        mocks: {
            accountEnding: 'Account ending in {{accountLast4}}'
        },
        modal: {
            annualNetIncome: 'Annual Net Income',
            annualNetIncomeHelperText: 'Include income from sources after taxes',
            annualNetIncomeInputErrorText: 'Enter income including sources after taxes',
            cliRequest: 'Request a credit limit increase',
            creditLimit: `{{creditLimit}}`,
            currentCreditLimit: 'CURRENT CREDIT LIMIT',
            desiredIncreaseInputErrorText: 'Enter the desired credit limit you want to request',
            desiredLimit: 'Desired Limit',
            desiredLimitHelperText: 'Enter the total credit limit you want to request',
            increaseLimitByMore: 'New desired limit must be at least $50 greater than current credit limit'
        },
        text: {
            legalText: `Your “Net Income” includes what you earn or reasonably expect to earn
      from employment, investments, retirement, social security benefits and
      public assistance. You can also include money that someone else
      deposits regularly into your account (individual or joint) and the
      amount that you have available to spend from your assets. If you are
      21 or over, you may also include the amount of someone else’s income
      that is regularly used to pay your expenses. Alimony, child support or
      separate maintenance income need not be included unless relied upon
      for credit. WI Residents Only: If this is an individual account,
      please also include your spouse’s income.`
        }
    }
};
export default en;
